/* src/app/private/components/temp-student-profile/update-student-document/update-student-document.component.scss */
/*# sourceMappingURL=update-student-document.component.css.map */
